import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-recuperar-contrasena',
  templateUrl: './recuperar-contrasena.component.html',
  styleUrls: ['./recuperar-contrasena.component.css']
})
export class RecuperarContrasenaComponent implements OnInit {
  email: string;

  constructor(
    private seguridadUsuarioService: SeguridadUsuarioService,
    private alertDialogService: AlertDialogService,
    private router: Router,
    private location: Location
  ) { 
    this.email = '';
  }

  ngOnInit(): void {
  }

  back(): void {
    this.location.back()
  }
  
  onSubmit(form: NgForm){
    if (!form.invalid) {   
      this.seguridadUsuarioService.recuperarPassword(this.email).subscribe((result) => {
        this.alertDialogService.open('La solicitud para RECUPERAR TU CONTRASEÑA fue enviada.'); //options
        this.router.navigate(['/']);
      });
    }
  }
}
